// extracted by mini-css-extract-plugin
export default {"record":"NewRecord_record__Kvxmo","numRecord":"NewRecord_numRecord__ZEBex","comma":"NewRecord_comma__eZ8EW"};